import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'subStr'
})
export class SubStrPipe implements PipeTransform {

    transform(value: any, length: number) {
        if (value == '' || value == null || value == undefined) return '';
        if (gbLen(value + '') <= length) return value;
        return gbSubStr((value as string), length) + '...';
    }

}
/**解决中英文字符宽度不一样，显示效果不好的问题*/
function gbLen(str: string) {
    var len = 0;
    for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
            len += 2;
        } else {
            len++;
        }
    }
    return len;
}
/**截断中英文有区别 中文字符占2 英文字符占1*/
function gbSubStr(str: string, length: number) {
    let len = length;
    let newStr = '';
    for (var i = 0; i < length; i++) {
        if (len <= 0) break;
        if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
            len -= 2;
        } else {
            len--;
        }
        newStr += str[i];
    }
    return newStr;
}